import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import TokenManagerHelper from "./helpers/token_manager_helper";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { applyInitialTheme } from "./slices/layouts/utils";
import { persistor, store } from "./store";
import { suppressResizeObserverErrors } from "./utils/suppressResizeObserverErrors";

suppressResizeObserverErrors();

applyInitialTheme();

TokenManagerHelper.initializeFromStorage();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

export type AppDispatch = typeof store.dispatch;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
